module.exports = new __parcel__URL__("service-bell-window.638bf1d2.svg").toString();